import SimpleMessagePage from './SimpleMessagePage';

export default SimpleMessagePage;
